/**
 * Deterministic HSL tint from a string (subject name, code, or course name).
 * Used by the list cards as a stand-in when the course has no thumbnail —
 * so every card still has a distinct visual identity, but nothing invented
 * or purchased-stock is on screen. Same input → same colour, always.
 */
export function subjectTint(seed: string | null | undefined): {
  bg: string;
  fg: string;
  border: string;
} {
  const s = (seed ?? "course").toString();
  let hash = 0;
  for (let i = 0; i < s.length; i++) {
    hash = (hash * 31 + s.charCodeAt(i)) >>> 0;
  }
  const hue = hash % 360;
  return {
    bg: `hsl(${hue}, 65%, 92%)`,
    fg: `hsl(${hue}, 55%, 28%)`,
    border: `hsl(${hue}, 60%, 78%)`,
  };
}

export function subjectInitials(seed: string | null | undefined): string {
  const s = (seed ?? "").trim();
  if (!s) return "•";
  const parts = s.split(/\s+/).filter(Boolean).slice(0, 2);
  return parts.map((p) => p[0]!.toUpperCase()).join("") || s[0]!.toUpperCase();
}
